import React, { useEffect } from "react";
import { GiAlarmClock } from "react-icons/gi";
import { useDispatch, useSelector } from "react-redux";
import { runbookSchedulerActions } from "../../actions/runbookScheduler.actions";
import Grid from "../common/Grid";
import Utils from "../../utils";
import CollapsibleCard from "../common/CollapsibleCard";

function NextExecutions({ hideTitle, ...props }) {
  const dispatch = useDispatch();
  const dashboardReducer = useSelector((state) => state.dashboard);

  const fetchNextExecutions = () => {
    let queryParams = {
      clientId: props.user.clientId,
      clientGuid: props.user.clientGuid,
      pageSize: 10,
      pageNumber: 1,
    };
    dispatch(runbookSchedulerActions.getNextExecutions(queryParams));
  };

  useEffect(() => {
    fetchNextExecutions();

    // Auto-refresh every 5 minutes (reduced from 1 minute for performance)
    const interval = setInterval(fetchNextExecutions, 300000);

    return () => clearInterval(interval);
    // eslint-disable-next-line
  }, [location]);

  const data = dashboardReducer.paginatedNextExecutionsResult?.data.map((r) => {
    return {
      ...r,
      executionDate: Utils.convertToDateTime(r.executionDate),
    };
  });

  return (
    <div data-tour="next-executions">
      <CollapsibleCard
        title="Next Executions"
        icon={<GiAlarmClock className="mb-1" />}
        defaultExpanded={true}
        hideHeader={hideTitle}
      >
      {!dashboardReducer.loadingNextExecutions && (!data || data.length === 0) ? (
        <div className="text-center text-muted py-3">
          <p>No scheduled executions</p>
        </div>
      ) : (
        <Grid
          data={data}
          displayColumns={["runbookId", "runbookName", "executionDate"]}
          pageNumber={0}
          totalPages={data?.length ? 1 : 0}
          loading={dashboardReducer.loadingNextExecutions}
          placeHolderLinesCount={3}
        ></Grid>
      )}
    </CollapsibleCard>
    </div>
  );
}

export default NextExecutions;
